<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          :hide-delimiters="headerlist.length > 1 && $vuetify.breakpoint.smAndDown ? false : true"
          :show-arrows="headerlist.length > 1 && !$vuetify.breakpoint.smAndDown ? true : false"
          :height="$vuetify.breakpoint.smAndDown ? '30vh' : 'calc(95vh - 165px)'"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              v-if="slide.showtext"
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="text-left background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.pnb') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            <!-- {{ $t('header.tagline') }} -->
                            Penerimaan Mahasiswa Baru
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="12">
            <v-row dense>
              <v-col cols="12" md="12">
                <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                  PNB - {{ $t('header.pnb') }}
                </h2>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-3">
                  <v-row dense class="text-center font-weight-bold">
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        :to="{ name: 'Dayatampung' }">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>house</v-icon>
                          <div class="text-subtitle-1">
                            Daya Tampung
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        :to="{ name: 'NewsDetail', query: { berita: 168 } }">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>mdi-cash</v-icon>
                          <div class="text-subtitle-1">
                            Biaya Penidikan
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        href="https://p4mp.pnb.ac.id/certificate"
                        target="_blank">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>mdi-certificate</v-icon>
                          <div class="text-subtitle-1">
                            Akreditasi
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        :to="{ name: 'Course' }">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>mdi-star-box</v-icon>
                          <div class="text-subtitle-1">
                            Program Studi
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        href="https://pnb.ac.id/"
                        target="_blank">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>mdi-web</v-icon>
                          <div class="text-subtitle-1">
                            Web Utama
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        href="https://sion.pnb.ac.id/"
                        target="_blank">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>mdi-account-plus</v-icon>
                          <div class="text-subtitle-1">
                            Daftar Ulang
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <v-card
                        class="d-flex flex-column w100"
                        :color="maincolor"
                        dark
                        :to="{ name: 'Pengaduanpmb' }">
                        <v-card-text class="white--text">
                          <v-icon size="50" dark>mdi-card-account-phone</v-icon>
                          <div class="text-subtitle-1">
                            Pengaduan PMB
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown" class="text-center">
                <!-- <v-divider vertical></v-divider> -->
              </v-col>
              <v-col cols="12" md="5">
                <vue-plyr>
                  <div class="plyr__video-embed">
                    <iframe
                      src="https://www.youtube.com/embed/nsBSlvCHX14"
                      allowfullscreen
                      allowtransparency
                      allow="autoplay">
                    </iframe>
                  </div>
                </vue-plyr>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid fill-height class="py-5 py-md-10 min-height-pages bacground-blue">
      <v-container class="px-0 px-md-3 white--text">
        <v-row>
          <v-col cols="12" md="12">
            <h2 class="text-md-h4 font-weight-bold">
              Jalur Penerimaan Mahasiswa Baru
            </h2>
          </v-col>
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">SNBP</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Seleksi Nasional Berdasarkan Prestasi
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'snbp' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">UTBK-SNBT</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Seleksi Nasional Berdasarkan Tes
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'snbt' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">MANDIRI</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Penerimaan Mahasiswa Baru Jalur Mandiri
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'mandiri' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">ALIH JENJANG</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Program Alih Jenjang
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'alih-jenjang' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">PASCASARJANA</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Program Pascasarjana
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'pasca-sarjana' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">D2 FAST TRACK</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Program D2 Fast Track
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'd2-fast-track' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w100">
                  <v-card-title class="font-weight-bold">KERJASAMA</v-card-title>
                  <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                    Program Kelas Kerjasama
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      :to="{ name: 'Jalurpenerimaan', params: { slug: 'kerjasama' }}">
                      <v-icon :color="maincolor">
                        mdi-arrow-right-circle
                      </v-icon>
                      <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-gray">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/about-01.jpg')"
                position="top">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.education') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  PNB offers applied masters, applied bachelors, diplomas, international programs, and a renewable energy specialization across its six departments (19 programs in total).
                </div>
                <div v-if="$i18n.locale === 'id'">
                  PNB menawarkan master terapan, sarjana terapan, diploma, program internasional, dan spesialisasi energi terbarukan di enam departemennya (total 19 program).
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Course' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/research-01.jpg')"
                position="top">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.research') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  As a research-focused institution, PNB encourages its lecturers and students to conduct research with robust and practical outcomes that will contribute to the research community and the industry.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  Sebagai lembaga yang berfokus pada penelitian, PNB mendorong dosen dan mahasiswanya untuk melakukan penelitian dengan hasil yang kuat dan praktis yang akan berkontribusi pada komunitas riset dan industri.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Research' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/pengabdian.jpeg')"
                position="top">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.community') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  PNB is committed to building characters and citizenship. The learning activities are linked with community services so students and lecturers can provide a meaningful contribution to society.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  PNB berkomitmen untuk membangun karakter dan kewarganegaraan. Kegiatan pembelajaran dikaitkan dengan pengabdian kepada masyarakat sehingga mahasiswa dan dosen dapat memberikan kontribusi yang berarti bagi masyarakat.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Community' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="12" class="align-self-end">
            <h2 class="text-md-h4 font-weight-bold sub-title-page">
              {{ $t('title.latestnews') }}
            </h2>
          </v-col>
        </v-row>
        <v-row v-if="newslist.length">
          <v-col
            class="d-flex"
            cols="12"
            md="4"
            v-for="(news, i) in newslist"
            :key="i">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="news.urlpic">
              </v-img>
              <v-card-subtitle>
                <h1 class="title font-weight-bold mb-3">
                  <router-link class="text-decoration-none text-ellipsis--2"
                    :title="news.judul_berita"
                    :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                    {{ news.judul_berita }}
                  </router-link>
                </h1>
                <div class="d-flex">
                  <v-chip
                    class="mr-1"
                    color="deep-orange"
                    small
                    dark
                    :title="news.tgl_berita">
                    <v-icon left small>
                      mdi-update
                    </v-icon>
                    <timeago :datetime="news.tgl_berita"></timeago>
                  </v-chip>
                  <v-chip
                    class="mr-1"
                    color="primary"
                    small
                    dark>
                    <v-icon left small>
                      mdi-alpha-c-circle
                    </v-icon>
                    {{ news.cat_berita }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <ShareNetwork
                    network="facebook"
                    :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                    :title="news.judul_berita"
                    :description="news.prev_berita"
                    :quote="news.prev_berita"
                    hashtags="international,pnb,bali"
                    class="text-decoration-none d-inline mr-1">
                    <v-icon color="indigo">
                      mdi-facebook
                    </v-icon>
                  </ShareNetwork>
                  <ShareNetwork
                    network="whatsapp"
                    :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                    :title="news.judul_berita"
                    :description="news.prev_berita"
                    :quote="news.prev_berita"
                    hashtags="international,pnb,bali"
                    class="text-decoration-none d-inline mr-1">
                    <v-icon color="green">
                      mdi-whatsapp
                    </v-icon>
                  </ShareNetwork>
                </div>
              </v-card-subtitle>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-html="news.prev_berita"></div>
              </v-card-text>
              <v-card-actions v-if="false">
                <v-btn
                  class="mx-2"
                  fab
                  depressed
                  dark
                  x-small
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  <v-icon dark>
                    mdi-arrow-right
                  </v-icon>
                </v-btn>
                <span>{{ $t('button.readmore') }}</span>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              large
              :color="maincolor"
              :to="{ name: 'News', query: { type: 'berita', category: 'pendaftaran' } }"
              dark>
              {{ $t('button.othernews') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!newslist.length">
          <v-col cols="12" md="12">
            <div class="grey--text my-2">
              Berita pada kategori ini tidak ditemukan.
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn
              block
              large
              :color="maincolor"
              :to="{ name: 'News', query: { type: 'berita', category: 'pendaftaran' } }"
              dark>
              {{ $t('button.othernews') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-gray">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="12">
            <h2 class="text-md-h4 font-weight-bold sub-title-page">
              {{ $t('title.department') }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="d-flex"
            cols="12"
            md="4"
            v-for="(jur, i) in jurlist"
            :key="i">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="jur.urlpic">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ jur.nama_jur }}
                </v-card-title>
              </v-img>
              <v-card-subtitle>
                Have {{ jur.prodi }} Study Programs
              </v-card-subtitle>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div class="text-ellipsis--3">
                  {{ jur.desc_jur }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Jurusan', params: { slug: jur.slug_jur }}">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4">
            <h2 class="text-md-h4 font-weight-bold sub-title-page">
              {{ $t('title.announcement') }}
            </h2>
            <div v-if="annoulist.length">
              <v-card
                v-for="(anno, i) in annoulist"
                :key="i"
                flat
                color="transparent">
                <v-card-text class="d-flex px-0">
                  <router-link
                    class="link-list-style text-decoration-none"
                    :to="{ name: 'NewsDetail', query: { berita: anno.id_berita } }">
                    <div class="d-flex align-center">
                      <div class="d-inline">
                        <div><b>{{ anno.judul_berita }}</b></div>
                        <div>{{ $t('title.date') }}: {{ anno.tgl_berita }}</div>
                        <div>{{ $t('title.category') }}: {{ anno.cat_berita }}</div>
                      </div>
                    </div>
                  </router-link>
                </v-card-text>
                <v-divider class="my-1"></v-divider>
              </v-card>
            </div>
            <div v-if="!annoulist.length">
              <div class="grey--text my-2">
                Tidak ada daftar pengumuman
              </div>
            </div>
            <v-btn
              class="mt-3"
              large
              :color="maincolor"
              dark
              :to="{ name: 'News', query: { type: 'pengumuman', category: 'pendaftaran' } }"
              exact>
              {{ $t('title.otheranno') }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <h2 class="text-md-h4 font-weight-bold sub-title-page">
              {{ $t('title.agenda') }}
            </h2>
            <div v-if="agendalist.length">
              <v-card
                v-for="(agen, i) in agendalist"
                :key="i"
                flat
                color="transparent">
                <v-card-text class="d-flex px-0">
                  <router-link
                    class="link-list-style text-decoration-none"
                    :to="{ name: 'NewsDetail', query: { berita: agen.id_berita } }">
                    <div class="d-flex align-center">
                      <div class="d-inline">
                        <div><b>{{ agen.judul_berita }}</b></div>
                        <div>{{ $t('title.date') }}: {{ agen.tgl_berita }} ~ {{ agen.tgl_end }}</div>
                        <div>{{ $t('title.category') }}: {{ agen.cat_berita }}</div>
                      </div>
                    </div>
                  </router-link>
                </v-card-text>
                <v-divider class="my-1"></v-divider>
              </v-card>
            </div>
            <div v-if="!agendalist.length">
              <div class="grey--text my-2">
                Tidak ada daftar agenda
              </div>
            </div>
            <v-btn
              class="mt-3"
              large
              :color="maincolor"
              dark
              :to="{ name: 'News', query: { type: 'agenda' } }"
              exact>
              {{ $t('title.otheragenda') }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <h2 class="text-md-h4 font-weight-bold sub-title-page">
              {{ $t('title.social') }}
            </h2>
            <div class="mt-4">
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FPoltekBali&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=149314212441326"
                width="340"
                height="500"
                style="border:none;overflow:hidden"
                scrolling="no"
                frameborder="0"
                allowfullscreen="true"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
              </iframe>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!-- dialog event -->
    <v-dialog
      v-model="dmodal.event"
      max-width="700px"
      scrollable
      persistent>
      <v-card
        flat
        tile>
        <v-card-title>
          Upcoming Events!
          <v-spacer></v-spacer>
          <v-icon class="float-right class-cursor" color="red" @click="dmodal.event = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-hover v-slot:default="{ hover }">
            <v-carousel
              :cycle="hover ? false : true"
              :hide-delimiters="$vuetify.breakpoint.smAndDown"
              :show-arrows="!$vuetify.breakpoint.smAndDown"
              height="auto"
              show-arrows-on-hover>
              <v-carousel-item
                v-for="(slide, i) in newslist"
                :key="i"
                :lazy-src="require('../assets/default.jpg')"
                :src="slide.urlpic">
                <v-container
                  fill-height
                  fluid
                  style="background-color: rgba(0,0,0,0.5);">
                  <v-layout
                    fill-height>
                    <v-flex
                      xs12
                      :align-self-baseline="!$vuetify.breakpoint.smAndDown"
                      :align-self-center="$vuetify.breakpoint.smAndDown">
                      <v-card
                        rounded="lg"
                        color="transparent"
                        flat
                        class="mt-md-12">
                        <v-card-text
                          :class="'text-center'">
                          <div>
                            <h3 class="white--text text-md-h5" v-text="slide.judul_berita"></h3>
                            <div class="mb-6 mt-1">
                              <v-chip
                                small
                                color="error">
                                <v-icon left small>
                                  mdi-calendar-range
                                </v-icon>
                                {{ slide.tgl_berita }} {{ slide.type_berita === 'event' ? ' ~ ' + slide.tgl_end : '' }}
                              </v-chip>
                            </div>
                            <v-btn
                              outlined
                              dark
                              class="text-capitalize"
                              :to="{ name: 'NewsDetail', query: { berita: slide.id_berita } }">
                              more info
                              <v-icon
                                small
                                right
                                dark>
                                mdi-arrow-right
                              </v-icon>
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-carousel-item>
            </v-carousel>
          </v-hover>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import Job from '../components/Job.vue';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';

export default {
  name: 'Landing',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    datalist: [],
    jurlist: [],
    newslist: [],
    balilist: [],
    agendalist: [],
    annoulist: [],
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    companylist: [],
    categorylist: [],
    statistic: {},
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
    },
    parambali: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    paramagenda: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
    },
    paramannou: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
    },
    parammitra: {
      limit: '',
      random: 1,
    },
    check: {
      keyword: '',
      location: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    slidecompany: null,
    slidermd: 0,
    listslide: [
      {
        text: '',
        url: '',
        img: require('./../assets/hero-image-man.jpeg'),
      },
      {
        text: 'Virtual Job Fair',
        url: 'https://bit.ly/VJFpnb20',
        img: require('./../assets/virtualjobfair.jpg'),
      },
    ],
    dmodal: {
      event: false,
    },
    onboarding: 0,
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-home.jpg'),
        showtext: true,
      },
    ],
  }),
  mounted() {
    this.getBerita();
    // this.getBali();
    this.getAgenda();
    this.getAnnou();
    // this.getJob();
    // this.getStatistic();
    // this.getJobcategory();
    this.getCompany();
    this.getJurusan();
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
      // this.getBali();
      this.getAgenda();
      this.getAnnou();
    },
    getJurusan() {
      this.jurlist = [];
      this.axios
        .get(
          this.api + '/public/jurusan',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                element.urlpic = this.api + '/upload/jurusan/' + element.img_jur;
                this.jurlist.push(element);
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStatistic() {
      this.statistic = {};
      this.axios
        .get(
          this.api + '/public/landing-statistic',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              this.statistic = resdata.data;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompany() {
      this.companylist = [];
      this.parammitra.limit = 12;
      this.parammitra.random = 1;
      this.axios
        .get(
          this.api + '/public/mitra',
          {
            params: this.parammitra,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.mitra_pic) {
                  element.urlpic = this.api + '/upload/mitra/' + element.mitra_pic;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.companylist.push(element);
              });
              // console.log(this.companylist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getJobcategory() {
      this.categorylist = [];
      this.axios
        .get(
          this.api + '/public/job-category',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              this.categorylist = resdata.data;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getJob() {
      this.datalist = [];
      this.axios
        .get(
          this.api + '/public/jobs',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                this.datalist.push(element);
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAnnou() {
      this.annoulist = [];
      this.paramannou.lang = this.$i18n.locale;
      this.paramannou.limit = 5;
      this.paramannou.type = 'pengumuman';
      this.paramannou.category = 'pendaftaran';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramannou,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.annoulist.push(element);
              });
              // console.log(this.annoulist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getAgenda() {
      this.agendalist = [];
      this.paramagenda.lang = this.$i18n.locale;
      this.paramagenda.limit = 5;
      this.paramagenda.type = 'agenda';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramagenda,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.agendalist.push(element);
              });
              // console.log(this.agendalist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendaftaran';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
              // if (this.newslist.length > 0) {
              //   this.eventDialog(true);
              // } else {
              //   this.eventDialog(false);
              // }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getBali() {
      this.balilist = [];
      this.parambali.lang = this.$i18n.locale;
      this.parambali.limit = 3;
      this.parambali.type = 'berita';
      this.parambali.category = 'bali';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.parambali,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.balilist.push(element);
              });
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    eventDialog(show) {
      this.dmodal.event = show;
    },
    next() {
      this.onboarding = this.onboarding + 1 === this.newslist.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.newslist.length - 1 : this.onboarding - 1;
    },
  },
  components: {
    Alertsp,
    Job,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ui-paralax-style{
    height: auto !important;
    /* min-height: 250px; */
  }
</style>
